import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line max-len
import { UniversalProductsCategory } from '@1po/1po-bff-fe-spec/generated/catalog/universal_products/response/GetUniversalProductsTreeResponse';
import { DataContainer } from 'components/DataContainer';
import { useUniversalProductsTree } from 'domains/catalog/Catalog.requests';
import ProductsBreadcrumb from 'pages/UniversalProductsPage/ProductsBreadcrumb';
import ProductsContainerPaged from 'pages/UniversalProductsPage/ProductsPage/ProductsContainerPaged';
import { MarginBox, Text } from 'UI';
import { getData } from 'utils';
import { useResetScroll } from 'utils/hooks/useResetScroll';

const getCategoryByNodeId = (categories: UniversalProductsCategory[], nodeId: string) =>
  categories.find((cat) => cat.nodeId === nodeId);

const ProductsPage = () => {
  const { level1, level2, level3 } = useParams<{ level1: string; level2: string; level3: string }>();
  const universalProductsTree = useUniversalProductsTree();
  const tree = getData(universalProductsTree);
  const renderCategory = useMemo(() => {
    const level1Category = getCategoryByNodeId(getData(universalProductsTree) ?? [], level1);
    const level2Category = getCategoryByNodeId(level1Category?.childCategories ?? [], level2);
    if (!level3) {
      return getCategoryByNodeId(level1Category?.childCategories ?? [], level2);
    }
    return getCategoryByNodeId(level2Category?.childCategories ?? [], level3);
  }, [level1, level2, level3, universalProductsTree]);

  useResetScroll();

  return (
    <DataContainer data={universalProductsTree}>
      <MarginBox mb={25}>
        <ProductsBreadcrumb tree={tree} />
      </MarginBox>
      <Text type={'h1_banner_light'}>{renderCategory?.name}</Text>
      {renderCategory?.nodeId ? <ProductsContainerPaged nodeId={renderCategory.nodeId} /> : null}
    </DataContainer>
  );
};

export default ProductsPage;
